import { Brand } from "../../utils/enums.utils";
import { LeadStatus } from "./leads-response.interface";

export interface CreateLeadsInterface {
  brand: Brand;
  description: string | null;
  estimated_amount: number | null;
  target_date: string | null;
  status: LeadStatus;
  remarks: string | null;
  brand_description: string | null;
  created_by_id: string | null;
  updated_by_id: string | null;
  client_id: string;
}

export interface UpdateLeadsInterface {
  id: string;
  brand?: Brand;
  description?: string | null;
  estimated_amount?: number | null;
  target_date?: string | null;
  status?: LeadStatus;
  remarks?: string | null;
  brand_description?: string | null;
  updated_by_id: string | null;
  client_id?: string;
}